import React, {
	useEffect,
	useContext,
	useState,
	useRef,
	// useCallback,
	// Fragment,
} from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { useHotkeys } from "react-hotkeys-hook";
import Swal from "sweetalert2";
import "../assets/css/modal.css";

//Contexto
import ConexContext from "../context/conex/ConexContext";

import { ReactComponent as InscribirIcon } from "../assets/img/iconos/acae_sign.svg";
import { ReactComponent as CloseIcon } from "../assets/img/iconos/acae_close.svg";
import { ReactComponent as CursoIcon } from "../assets/img/iconos/acae_course.svg";
import { ReactComponent as SearchIcon } from "../assets/img/iconos/acae_zoom.svg";
import { ReactComponent as PagoIcon } from "../assets/img/iconos/acae_money.svg";
import { ReactComponent as AgreementIcon } from "../assets/img/iconos/acae_agreement.svg";
import { ReactComponent as AcaeArrow } from "../assets/img/iconos/acae_arrow.svg";
import { ReactComponent as AsistenciaIcon } from "../assets/img/iconos/acae_kimono.svg";
import { ReactComponent as CheckIcon } from "../assets/img/iconos/acae_check.svg";
// import { ReactComponent as DownloadIcon } from "../assets/img/download.svg";
import { ReactComponent as BeltIcon } from "../assets/img/iconos/acae_belt.svg";
import { ReactComponent as OptionsIcon } from "../assets/img/iconos/acae_options.svg";
import { ReactComponent as DojoIcon } from "../assets/img/iconos/acae_dojo.svg";
import { ReactComponent as UserIcon } from "../assets/img/iconos/acae_user.svg";
import { ReactComponent as EventIcon } from "../assets/img/iconos/acae_event.svg";
import { ReactComponent as SessionIcon } from "../assets/img/iconos/acae_belt.svg";
import { ReactComponent as PdfIcon } from "../assets/img/iconos/acae_pdf.svg";
import { ReactComponent as XlsxIcon } from "../assets/img/iconos/acae_xlsx.svg";

import desc from "../assets/img/desc.svg";
import asc from "../assets/img/asc.svg";
import CursoImagenMod from "./CursoImagenMod";
import FloatingMenu from "./comun/FloatingMenu";

const InscripcionMod = (props) => {
	const WaitSearch = require("../config/config.json").WaitSearch;
	const {
		peticion,
		loc,
		perfil_admin,
		perfil_adm_dojo,
		perfil_dojo,
		peticionPDF,
		Cargando,
	} = useContext(ConexContext);
	const { lang } = useParams();
	//atajos de teclado
	useHotkeys("esc", cierra, {
		enableOnContentEditable: true,
		enableOnFormTags: true,
		enabled: props.show !== 0 && !Cargando,
	});
	const navigate = useNavigate();
	const { caller } = props;
	const [Curso, setCurso] = useState(null); // cursos seleccionado
	const [AlumnosList, setAlumnosList] = useState([]); // alumnos lista
	const [Cambios, setCambios] = useState([]); // cambios para subir
	const [Filtro, setFiltro] = useState(""); // filtro para busqueda
	const [FiltroAux, setFiltroAux] = useState(""); // filtroAux para busqueda
	// Estado para manejar el orden (por nombre y si es ascendente o descendente)
	const [ordenList, setOrdenList] = useState({
		campo: "nombreComp",
		direccion: "asc",
	});
	const [selectAsociado, setSelectAsociado] = useState({
		nombre: "",
		apellido: "",
		numAcae: "",
	}); // Asociado a inscribir
	const [verMas, setVerMas] = useState(false);
	const [verImagen, setVerImagen] = useState(false);
	const [inscritos, setinscritos] = useState(0);
	const [pagados, setpagados] = useState(0);
	const [asistidos, setasistidos] = useState(0);
	const searchBarRef = useRef();
	const tableContainerRef = useRef(null);
	const timeoutRef = useRef(null);

	const menuRefs = useRef({});
	const rFiltro = useRef();
	const [ColumnaFiltro, setColumnaFiltro] = useState("Todas"); //filtro del select
	const [activeMenu, setActiveMenu] = useState(null);
	const [detallesExpandido, setDetallesExpandido] = useState(false);
	const [modoInscripcion, setModoInscripcion] = useState(false);
	const [modalClausulas, setModalClausulas] = useState(false);
	const [hasReadClausulas, setHasReadClausulas] = useState(false);

	// const [scrolled, setScrolled] = useState(false);

	const toggleMenu = (id) => {
		setActiveMenu(activeMenu === id ? null : id);
	};

	const handleChange = () => {
		setFiltroAux(searchBarRef.current.value);
		// Limpiamos cualquier timeout anterior
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Esperamos 1.5 segundos desde la última tecla
		timeoutRef.current = setTimeout(() => {
			if (searchBarRef.current) {
				setFiltro(searchBarRef.current.value);
			}
		}, WaitSearch);
	};

	const meses = [
		"Enero",
		"Febrero",
		"Marzo",
		"Abril",
		"Mayo",
		"Junio",
		"Julio",
		"Agosto",
		"Septiembre",
		"Octubre",
		"Noviembre",
		"Diciembre",
	];

	const toggleDetalles = () => {
		setDetallesExpandido(!detallesExpandido);
	};

	//EFFECT
	useEffect(() => {
		async function ver() {
			const curso = await peticion("/cursos/ver?id=" + props.show);
			setCurso(curso.res);
			// Busqueda por defecto
			const alumnos = await peticion(
				`/cursos/listAlum?columna=${"Todas"}&filtro=${""}&cod=${
					curso?.res?.cfOrganiz
				}&curso=${curso?.res?.idCurso}&alumno=${props?.idAsociado}&`
			);
			console.log('ssdfg');

			if (alumnos.estado === 0) {
				setCambios([]);
				setAlumnosList(alumnos.res);
				setinscritos(alumnos.inscritos);
				setpagados(alumnos.pagados);
				setasistidos(alumnos.asistidos);
			}
		}

		if (props.show > 0) {
			ver();
			if (perfil_adm_dojo || perfil_admin) {
				// searchBarRef.current.focus();
			}
		}
	}, [
		props.show,
		peticion,
		perfil_admin,
		perfil_adm_dojo,
		props.apuntate,
		props.idAsociado,
	]);

	useEffect(() => {
		if (caller !== "cursos") {
			setFiltro(selectAsociado?.numAcae);
		}
		// eslint-disable-next-line
	}, [selectAsociado]);

	useEffect(() => {
		async function buscar() {
			if (perfil_adm_dojo || perfil_admin) {
				// Pendiente de desarrollar
				const alumnos = await peticion(
					`/cursos/listAlum?columna=${ColumnaFiltro}&filtro=${Filtro}&cod=${Curso?.cfOrganiz}&curso=${Curso?.idCurso}&alumno=${props?.idAsociado}&`
				);
				setAlumnosList(alumnos.res);
				setinscritos(alumnos.inscritos);
				setpagados(alumnos.pagados);
				setasistidos(alumnos.asistidos);
			}
		}

		if (props.show === 0 || Curso === null) return;
		buscar();
		// eslint-disable-next-line
	}, [Filtro, ColumnaFiltro]);

    const clausulasScrollRef = useRef(null);

	useEffect(() => {
        if (!modalClausulas) return;
        setHasReadClausulas(false);

        const el = clausulasScrollRef.current;
        if (!el) return;

        const EPS = 2; // tolerancia en px para subpíxeles/zoom

        const handleScroll = () => {
            // Si no hay overflow, habilitar directamente
            const noOverflow = el.scrollHeight <= el.clientHeight + EPS;
            if (noOverflow) {
                setHasReadClausulas(true);
                return;
            }
            // Detectar fondo con tolerancia
            const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - EPS;
            if (atBottom) setHasReadClausulas(true);
        };

        // Comprobación inicial
        requestAnimationFrame(() => requestAnimationFrame(handleScroll));

        el.addEventListener("scroll", handleScroll, { passive: true });

        // Recalcular si cambia el tamaño
        const onResize = () => handleScroll();
        window.addEventListener("resize", onResize);

        // Observa cambios de tamaño del contenedor
        let ro;
        if ("ResizeObserver" in window) {
            ro = new ResizeObserver(handleScroll);
            ro.observe(el);
            if (el.firstElementChild) ro.observe(el.firstElementChild);
        }

        return () => {
            el.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", onResize);
            if (ro) ro.disconnect();
        };
    }, [modalClausulas]);

	// Función para manejar el cambio de orden (cambiar de ascendente a descendente)
	const handleOrdenar = (campo) => {
		setOrdenList((prevOrden) => {
			if (prevOrden.campo === campo) {
				// Si ya estamos ordenando por el mismo campo, cambiar la dirección
				return {
					campo,
					direccion: prevOrden.direccion === "asc" ? "desc" : "asc",
				};
			}
			// Si estamos ordenando por un campo diferente, establecer ascendente por defecto
			return { campo, direccion: "asc" };
		});
	};

	const PeticionPlantilla = async () => {
		try {
			peticionPDF(`/cursos/descargar_plantilla`, { method: "POST" }).then(
				async (res) => {
					if (!res) {
						Swal.fire({
							title: "No se ha encontrado la plantilla",
							text: "La plantilla no existe en el servidor",
							showConfirmButton: true,
							icon: "error",
							heightAuto: false,
						});
						return;
					}
				}
			);
		} catch (error) {
			console.error("Error al descargar el archivo", error);
		}
	};

	const PeticionPlantillaExcel = async () => {
		try {
			peticionPDF(`/cursos/descargar_plantilla_Excel`, { method: "POST" }).then(
				async (res) => {
					if (!res) {
						Swal.fire({
							title: "No se ha encontrado la plantilla",
							text: "La plantilla no existe en el servidor",
							showConfirmButton: true,
							icon: "error",
							heightAuto: false,
						});
						return;
					}
				}
			);
		} catch (error) {
			console.error("Error al descargar el archivo", error);
		}
	};

	const PeticionExcelComp = async () => {
		try {
			peticionPDF(
				`/cursos/descargar_alumnosExcelComp?&cod=${Curso?.cfOrganiz}&curso=${
					Curso?.idCurso
				}&nombre=${`${Curso?.ciudad} ${
					meses[parseInt(Curso?.fechaFin.split("-")[1]) - 1]
				} ${Curso?.fechaFin.split("-")[0]}`}&`,
				{ method: "POST" }
			).then(async (res) => {
				if (!res) {
					Swal.fire({
						title: "Listado erróneo",
						text: "Ha habido un problema en el servidor",
						showConfirmButton: true,
						icon: "error",
						heightAuto: false,
					});
					return;
				}
			});
		} catch (error) {
			console.error("Error al descargar el archivo", error);
		}
	};

		const PeticionExcel = async () => {
		try {
			peticionPDF(
				`/cursos/descargar_alumnosExcel?&cod=${Curso?.cfOrganiz}&curso=${
					Curso?.idCurso
				}&nombre=${`${Curso?.ciudad} ${
					meses[parseInt(Curso?.fechaFin.split("-")[1]) - 1]
				} ${Curso?.fechaFin.split("-")[0]}`}&`,
				{ method: "POST" }
			).then(async (res) => {
				if (!res) {
					Swal.fire({
						title: "Listado erróneo",
						text: "Ha habido un problema en el servidor",
						showConfirmButton: true,
						icon: "error",
						heightAuto: false,
					});
					return;
				}
			});
		} catch (error) {
			console.error("Error al descargar el archivo", error);
		}
	};

	function cambiado(elem, apartado, idSesion) {
		const Cambiado = Cambios.find((o) => o.idAso === elem.idAso);
		// const Objoriginal = AlumnosList.find((o) => o.idAso === elem.idAso);
		// if (!Objoriginal) return false;
		if (!Cambiado) return false;

		if (apartado === "CLAUSULA") {
			// return Objoriginal.pagado !== elem.pagado;
			return Cambiado.clausulaAceptada !== elem.clausulaAceptada;
		}
		if (apartado === "PAGADO") {
			// return Objoriginal.pagado !== elem.pagado;
			return Cambiado.pagado !== elem.pagado;
		}
		if (apartado === "ASISTENCIA") {
			// return Objoriginal.asistencia !== elem.asistencia;
			return Cambiado.asistencia !== elem.asistencia;
		}
		if (apartado === "SESIONES") {
			if (!Array.isArray(Cambiado.sesiones) || !Array.isArray(elem.sesiones)) return false;
			const SESIONoriginal = Cambiado.sesiones.find(
				(o) => o.idsesion === idSesion
			);
			const SESIONcambiada = elem.sesiones.find(
				(o) => o.idsesion === idSesion
			);
			if (!SESIONoriginal && SESIONcambiada) return true;
			if (SESIONoriginal && !SESIONcambiada) return true;
			if (!SESIONoriginal && !SESIONcambiada) return false;
			return (
				// SESIONoriginal.asistencia !== SESIONcambiada.asistencia ||
				// SESIONoriginal.pagado !== SESIONcambiada.pagado ||
				SESIONoriginal.tipo !== SESIONcambiada.tipo ||
				SESIONoriginal.idsesion !== SESIONcambiada.idsesion ||
				SESIONoriginal.nasisevento !== SESIONcambiada.nasisevento
			);
		}
		return false;
	}

	//guarda los cambios
	function guarda() {
		if (Cambios.length===0) return

		try {
			peticion("/cursos/subirCambios", {
				method: "POST",
				json: {
					idCurso: Curso?.idCurso,
					cambios: Cambios,
				},
			}).then((pet) => {
				if (pet.estado === 0) {
					peticion(
						`/cursos/listAlum?columna=${ColumnaFiltro}&filtro=${Filtro}&cod=${Curso?.cfOrganiz}&curso=${Curso?.idCurso}&alumno=${props?.idAsociado}&`
					).then((pet2) => {
						setCambios([]);
						setAlumnosList(pet2.res);
						setinscritos(pet2.inscritos);
						setpagados(pet2.pagados);
						setasistidos(pet2.asistidos);
					});
				}
			});
		} catch (error) {
			console.error("Error inesperado al subir los cambios", error);
		}
	}

	//cierra el modal
	function cierra() {
		if (
			Cambios &&
			Cambios.length > 0 
		) {
			Swal.fire({
				title: loc("¿Guardar los cambios?"),
				text: loc("Hay cambios sin guardar. ¿Qué quieres hacer?"),
				icon: "warning",
				showCancelButton: true,
				confirmButtonText: loc("Guardar"),
				cancelButtonText: loc("Cancelar"),
				showDenyButton: true,
				denyButtonText: loc("Descartar"),
			}).then((result) => {
				if (result.isConfirmed) {
					guarda();
					props.onHide();
				} else if (result.isDenied) {
					setCambios([]);
					props.onHide();
				} else {
					return;
				}
			});
			
		} else {
			setCurso(null);
			setOrdenList({ campo: "nombre", direccion: "asc" });
			setFiltro("");
			setFiltroAux("");
			setColumnaFiltro("Todas");
			setAlumnosList([]);
			setCambios([]);
			setinscritos(0);
			setpagados(0);
			setasistidos(0);
			setVerMas(false);
			setModoInscripcion(false);
			setSelectAsociado({
				nombre: "",
				apellido: "",
				numAcae: "",
			});
			props.onHide();
		}
	}

	function sonIgualesIgnorandoOrden(obj1, obj2, clavesIgnoradas = []) {
		const claves = Object.keys(obj1).filter((key) => !clavesIgnoradas.includes(key));
		return claves.every((key) => {
			const val1 = obj1[key];
			const val2 = obj2[key];
			if (key === "sesiones" && Array.isArray(val1) && Array.isArray(val2)) {
			const ordenar = (a, b) => a.idsesion - b.idsesion;
			const sesiones1 = [...val1].sort(ordenar);
			const sesiones2 = [...val2].sort(ordenar);
			return JSON.stringify(sesiones1) === JSON.stringify(sesiones2);
			}
			return JSON.stringify(val1) === JSON.stringify(val2);
		});
	}

	function getAsociadoActions(elem) {
		const acciones = [];

		if (perfil_admin || (perfil_adm_dojo && elem.codigo_dojo === perfil_dojo)) {
			acciones.push({
				label: `${loc("Ir a la ficha del asociado")}`,
				icon: <AcaeArrow className="icon" />,
				link: true,
				onClick: () =>
					navigate(`/${lang}/app/asociados/usuario/${elem.numacae}`),
			});
		}

		if (perfil_admin || perfil_adm_dojo) {
			acciones.push({
				label: loc("Ver dojo") + " " + elem?.dojo,
				icon: <AcaeArrow className="icon" />,
				link: true,
				href: `/${lang}/app/dojos/asoc_0/${elem.codigo_dojo}`,
			});
		}

		if (perfil_admin || perfil_adm_dojo) {
			acciones.push({
				label: loc("Buscar asociados de este dojo"),
				icon: <DojoIcon className="icon" />,
				onClick: () => {
					setColumnaFiltro("Dojo.nombre");
					setFiltroAux(elem?.dojo);
					setFiltro(elem?.dojo);
				},
			});
		}

		return acciones;
	}

	const accionesPorAsociado = AlumnosList.reduce((acc, elem) => {
		acc[elem.idAso] = getAsociadoActions(elem);
		return acc;
	}, {});

	// useEffect(() => {
	// 	if (props.show === 0) return;
	// 	const el = tableContainerRef.current;
	// 	if (!el) return;

	// 	// Inicializa el estado según el scroll actual
	// 	// setScrolled(el.scrollTop !== 0);

	// 	// const handleScroll = () => {
	// 	// 	setScrolled(el.scrollTop !== 0);
	// 	// };

	// 	el.addEventListener("scroll", handleScroll);

	// 	return () => {
	// 		el.removeEventListener("scroll", handleScroll);
	// 	};
	// }, [props.show]);

	// useEffect(() => {
	// 	console.log(Cambios)
	// }, [Cambios]);

	function inscritoTemp(alumno) {
		if (!Array.isArray(alumno.sesiones) && !Array.isArray(Cambios.find((al) => al.idAso === alumno.idAso).sesiones)) return false;
		const tieneSesion = alumno.sesiones.some(s => s.tipo === "S") || (Cambios.find((al) => al.idAso === alumno.idAso)?.sesiones.some(s => s.tipo === "S"));
		const tieneEvento = alumno.sesiones.some(s => s.tipo === "E" && s.nasisevento > 0) || (Cambios.find((al) => al.idAso === alumno.idAso)?.sesiones.some(s => s.tipo === "E" && s.nasisevento > 0));
		return tieneSesion || tieneEvento;
	}

	if (props.show === 0) return "";
	else
		return (
			<main className="modal-wrapper">
				<div className="modal-container modal-container--noscroll backdrop content-wrapper">
					<div className="modal-header sticky-header" style={modoInscripcion ? { paddingTop: 0 } : undefined}>
						{modoInscripcion ? (
							<div className="flex-row-item gap-small">
								<div className="inscribir-asociado-container search">
									<form onSubmit={(e) => e.preventDefault()}>
										<input
											className="asociado-search"
											ref={searchBarRef}
											value={FiltroAux}
											type="search"
											placeholder={loc("Buscar")}
											onChange={handleChange}
										/>
										{Filtro === "" ? (
											<SearchIcon alt="" title="" />
										) : (
											<CloseIcon
												className="red-fill"
												onClick={() => { setFiltro(""); setFiltroAux(""); searchBarRef.current?.focus(); }}
												alt="" title=""
											/>
										)}
									</form>
								</div>
								<div className="flex-row-item no-gap estado-container__count">
									<PagoIcon />
									<span>{pagados}{"/"}</span>
									<span className="text-bold">{inscritos}</span>
								</div>
								<div className="flex-row-item no-gap estado-container__count">
									<AsistenciaIcon />
									<span>{asistidos}{"/"}</span>
									<span className="text-bold">{inscritos}</span>
								</div>
							</div>
						) : (
							<div className="flex-wrapper">
								<InscribirIcon className="section-icon asociados" />
								<h3>{loc("Inscripción")}</h3>
							</div>
						)}
						<CloseIcon
							onClick={cierra}
							className="modal_close-icon"
							alt={loc("Cerrar ventana")}
							title={loc("Cerrar ventana")}
						/>
					</div>
					{!modoInscripcion && (<div className="modal-header">
						<div className={`modal-content-outer-wrapper inscripcion-modal-content-outer-wrapper`}>
							{Curso && detallesExpandido && (
								<div
									className="inscribir-asociado-container--row">
									<div className="inscribir-asociado__img">
										{Curso?.imagen ? (
											<img
												className="curso-img"
												style={{ cursor: "pointer" }}
												src={
													Curso?.imagen !== null
														? `/curso/${Curso?.imagen}`
														: "/curso/default.jpg"
												}
												alt="Curso"
												onClick={() => {
													setVerImagen(true);
												}}
											/>
										) : (
											<div className="upload-curso-img__default">
												{loc("Sin cartel")}
											</div>
										)}
									</div>
									<div className="flex-column gap-small grow">
										<div className="flex-column gap-small">
											<div className="flex-row-item gap-small">
												<h4>{Curso?.titulo}</h4>
												<div className="flex-row-item gap-small location">
													<CursoIcon className="section-icon" />
													<span>{Curso?.ciudad}</span>
												</div>
											</div>
											<div className="flex-row-item date">
												<span>
													{new Date(Curso?.fechaIni)
														.toLocaleDateString(
															lang + "-" + lang.toUpperCase(),
															{
																day: "2-digit",
																month: "short",
																year: "numeric",
															}
														)
														.toUpperCase()}
												</span>
												-
												<span>
													{new Date(Curso?.fechaFin)
														.toLocaleDateString(
															lang + "-" + lang.toUpperCase(),
															{
																day: "2-digit",
																month: "short",
																year: "numeric",
															}
														)
														.toUpperCase()}
												</span>
											</div>
										</div>
										<div className="observaciones-bg">
											<p className={`observaciones ${verMas && "show"}`}>
												{Curso?.obs}
											</p>
											<button
												className="ver-mas__button"
												onClick={() => setVerMas(!verMas)}>
												{verMas ? loc("Ver menos") : loc("Ver más")}
											</button>
										</div>
									</div>
								</div>
							)}

							<button className="expand button primary"
								onClick={() => toggleDetalles()}>
								{ detallesExpandido ? "Ocultar detalles del curso" : "Mostrar detalles del curso"}
							</button>

							<div
								className={`inscribir-asociado-container select-sesiones ${
									(perfil_adm_dojo || perfil_admin) ? "underline " : ""
								}`}
								style={{ marginTop: detallesExpandido ? "15px" : "45px" }}>
								<div className="secciones-lista flex-column gap-small">
									<div className="grid card gap-small">
										{Curso?.aSesion
											?.filter((elem) => elem.tipo === "S")
											.sort((a, b) => {
												// Ordenar por 'fecha'
												if (a.fecha !== b.fecha) {
													return new Date(a.fecha) - new Date(b.fecha);
												}
												// Ordenar por 'idses'
												return a.idses - b.idses;
											})
											.map((elem, i) => (
												<div
													className="flex-row space-between gap-small sesion"
													key={i}>
													<div className="flex-row-item space-between align-start">
														<div className="flex-row-item gap-small">
															<BeltIcon className="sesion-card-icon" />
															<span className="tipo-sesion">
																{loc("Sesión") + " " + (i + 1)}
															</span>
														</div>
													</div>
													<div className="sesion-info">
														<div className="date">
															{new Intl.DateTimeFormat(
																lang + "-" + lang.toUpperCase(),
																{
																	day: "numeric",
																	month: "long",
																	year: "numeric",
																}
															)
																.format(new Date(elem.fecha))
																.toUpperCase()}
														</div>
														<div className="date">{elem?.descripcion}</div>
													</div>
												</div>
											))}

										{Curso?.aSesion
											?.filter((elem) => elem.tipo === "E")
											.sort((a, b) => {
												// Ordenar por 'fecha'
												if (a.fecha !== b.fecha) {
													return new Date(a.fecha) - new Date(b.fecha);
												}
												// Ordenar por 'idses'
												return a.idses - b.idses;
											})
											.map((elem, i) => (
												<div
													className="flex-row space-between gap-small sesion sesion-evento"
													key={i}>
													<div className="flex-row-item space-between align-start">
														<div className="flex-row-item gap-small">
															<AsistenciaIcon className="sesion-card-icon" />
															<span className="tipo-sesion">
																{loc("Evento") + " " + (i + 1)}
															</span>
														</div>
													</div>
													<div className="sesion-info">
														<div className="date">
															{new Intl.DateTimeFormat(
																lang + "-" + lang.toUpperCase(),
																{
																	day: "numeric",
																	month: "long",
																	year: "numeric",
																}
															)
																.format(new Date(elem.fecha))
																.toUpperCase()}
														</div>
														<div className="date">{elem?.descripcion}</div>
													</div>
												</div>
											))}
									</div>
								</div>
							</div>
						</div>
						{(perfil_adm_dojo || perfil_admin) &&
						<div className={`flex-row-item space-between`}>
							<div className="flex-row-item gap-small no-padding">
								<div className="inscribir-asociado-container search">
									<form onSubmit={(e) => e.preventDefault()}>
										<input
											className="asociado-search"
											ref={searchBarRef}
											value={FiltroAux} // valor inicial
											type="search"
											placeholder={loc("Buscar")}
											onChange={handleChange}
										/>
										{Filtro === "" ? (
											<SearchIcon alt="" title="" />
										) : (
											<CloseIcon
												className="red-fill"
												onClick={() => {
													setFiltro("");
													setFiltroAux("");
													searchBarRef.current.focus();
												}}
												alt=""
												title=""
											/>
										)}
									</form>
								</div>
								<select
									className="width-auto"
									ref={rFiltro}
									value={ColumnaFiltro}
									onChange={() => {
										setColumnaFiltro(rFiltro.current.value);
									}}>
									<option value="Todas">{loc("Todas las columnas")}</option>
									{[
										{ nombre: loc("Num ACAE"), valor: "asociado.numacae" },
										{ nombre: loc("Nombre"), valor: "asociado.nombre" },
										{ nombre: loc("Apellidos"), valor: "asociado.apellido" },
										{ nombre: loc("Dojo"), valor: "Dojo.nombre" },
									].map((elem) => (
										<option value={elem.valor} key={elem.valor}>
											{elem.nombre}
										</option>
									))}
								</select>
								{perfil_adm_dojo || perfil_admin ? (
									<div className="flex-row-item no-gap estado-container__count">
										<PagoIcon />
										<span>
											{pagados}
											{"/"}
										</span>
										<span className="text-bold">{inscritos}</span>
									</div>
								) : null}
								{perfil_adm_dojo || perfil_admin ? (
									<div className="flex-row-item no-gap estado-container__count">
										<AsistenciaIcon />
										<span>
											{asistidos}
											{"/"}
										</span>
										<span className="text-bold">{inscritos}</span>
									</div>
								) : null}
								{perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz && (
									Curso?.aSesion
										?.filter((elem) => elem.tipo === "E")
										.map((elem, i) => {
											// Contar asistentes para este evento específico
											const asistentesEvento = AlumnosList
												.filter(alumno => alumno.inscrito === true)
												.reduce((suma, alumno) => {
													// Buscar si hay cambios pendientes para este alumno
													const alumnoConCambios = Cambios.find(cambio => cambio.idAso === alumno.idAso);
													const sesionesAUsar = alumnoConCambios?.sesiones || alumno.sesiones;
													
													if (Array.isArray(sesionesAUsar)) {
														const sesionEvento = sesionesAUsar.find(sesion => sesion.idsesion === elem.idses);
														return suma + (sesionEvento?.nasisevento || 0);
													}
													return suma;
												}, 0);
											
											return (
												<div className="flex-row-item gap-small estado-container__count" key={elem.idses}>
													<div>
														{elem?.descripcion}
													</div>
													<div className="text-bold">
														{asistentesEvento}
													</div>
												</div>
											);
										})
								)}
								{/* <button className="cta estado-container__count" title={loc("Ver cláusula")}>
									<SignIcon />
								</button> */}
							</div>
							{((perfil_admin) || (perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz)) && (
								<div className="flex-row-item gap-small">
									<div className="double-button-group-wrapper">
										<div className="double-button-tag">
											{loc("Inscripciones")}
										</div>
										<div className="double-button-group">
											<button
												className="button primary"
												onClick={() => {
													if (Cambios && Cambios.length > 0) {
														Swal.fire({
															title: loc("¿Guardar los cambios?"),
															text: loc("Hay cambios sin guardar. ¿Qué quieres hacer?"),
															icon: "warning",
															showCancelButton: true,
															confirmButtonText: loc("Guardar"),
															cancelButtonText: loc("Cancelar"),
															showDenyButton: true,
															denyButtonText: loc("Descartar"),
														}).then((result) => {
															if (result.isConfirmed) {
																guarda();
																PeticionExcel();
															} else if (result.isDenied) {
																setCambios([]);
																PeticionExcel();
															} else {
																return;
															}
														});
													}else{
														PeticionExcel();
													}
												}}>
												<PdfIcon className="tiny-icon" />
											</button>
											<button
												className="button primary"
												onClick={() => {
													if (Cambios && Cambios.length > 0) {
														Swal.fire({
															title: loc("¿Guardar los cambios?"),
															text: loc("Hay cambios sin guardar. ¿Qué quieres hacer?"),
															icon: "warning",
															showCancelButton: true,
															confirmButtonText: loc("Guardar"),
															cancelButtonText: loc("Cancelar"),
															showDenyButton: true,
															denyButtonText: loc("Descartar"),
														}).then((result) => {
															if (result.isConfirmed) {
																guarda();
																PeticionExcelComp();
															} else if (result.isDenied) {
																setCambios([]);
																PeticionExcelComp();
															} else {
																return;
															}
														});
													}else{
														PeticionExcelComp();
													}
												}}>
												<XlsxIcon className="tiny-icon" />
											</button>
										</div>
									</div>
									<div className="double-button-group-wrapper">
										<div className="double-button-tag">
											{loc("Plantilla")}
										</div>
											<div className="double-button-group">
												<button
													className="button primary"
													onClick={() => {
														PeticionPlantilla();
													}}>
													<PdfIcon className="tiny-icon" />
												</button>
												<button
													className="button primary"
													onClick={() => {
														PeticionPlantillaExcel();
													}}>
													<XlsxIcon className="tiny-icon" />
												</button>
											</div>
										</div>
								</div>
							)}
						</div>
						}
					</div>
					)}
					<div
						className="modal-content-scroll inscripciones"
						ref={tableContainerRef}>
						<table className="table-container">
							<thead className="table-headers">
								<tr className="table-headers--tr">
									<th className="table-headers--th tiny-column"></th>
									<th className="table-headers--th tiny-column" title="Pago">
										<PagoIcon className="tiny-icon" />
									</th>
									<th
										className="table-headers--th tiny-column"
										title="Asistencia">
										<AsistenciaIcon className="tiny-icon" />
									</th>
									{Curso?.aSesion
										?.filter((elem) => elem.tipo === "S")
										.map((elem, i) => (
											<th
												className="table-headers--th tiny-column"
												style={{ textAlign: "center" }}
												key={elem.idses}
												title={elem.descripcion}>
													<SessionIcon className="tiny-icon" />
												{/* {loc("S") + (i + 1)} */}
											</th>
										))}
									{Curso?.aSesion
										?.filter((elem) => elem.tipo === "E")
										.map((elem, i) => (
											<th
												className="table-headers--th short-column-expanded"
												style={{ justifyContent: "center" }}
												key={elem.idses}
												title={elem.descripcion}>
													<EventIcon className="tiny-icon" />
												{/* {loc("E") + (i + 1)} */}
											</th>
										))}
									{Curso?.actClau&&
										<th className="table-headers--th tiny-column" title="Cláusula">
											<AgreementIcon className="tiny-icon" />
										</th>
									}
									<th className="table-headers--th wide-column">
										<button>{loc("Num ACAE")}</button>
									</th>
									<th className="table-headers--th">
										<button onClick={() => handleOrdenar("nombreComp")}>
											{loc("Nombre y apellidos")}
										</button>
										<ul className="listaordena flex-item-row gap-small">
											{ordenList.campo === "nombreComp" &&
												ordenList.direccion === "desc" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											{ordenList.campo === "nombreComp" &&
												ordenList.direccion === "asc" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
										</ul>
									</th>
									<th className="table-headers--th">
										<button onClick={() => handleOrdenar("dojo")}>
											{loc("Dojo")}
										</button>
										<ul className="listaordena flex-item-row gap-small">
											{ordenList.campo === "dojo" &&
												ordenList.direccion === "desc" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											{ordenList.campo === "dojo" &&
												ordenList.direccion === "asc" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
										</ul>
									</th>
									<th className="table-headers--th wide-column">
										<button onClick={() => handleOrdenar("adulto")}>
											{loc("Adulto")}
										</button>
										<ul className="listaordena flex-item-row gap-small">
											{ordenList.campo === "adulto" &&
												ordenList.direccion === "desc" && (
													<li>
														<img src={desc} alt="ordena descendente" />
													</li>
												)}
											{ordenList.campo === "adulto" &&
												ordenList.direccion === "asc" && (
													<li>
														<img src={asc} alt="ordena ascendente" />
													</li>
												)}
										</ul>
									</th>
									<th className="table-headers--th wide-column">
										<button>{loc("Última cuota")}</button>
									</th>
								</tr>
							</thead>
							<tbody className="table-results table-inscripcion-mod">
								{AlumnosList &&
									AlumnosList.sort((a, b) => {
										// Prioridad 1: usuario propio primero
										if (a.idAso === props.idAsociado) return -1;
										if (b.idAso === props.idAsociado) return 1;
										// Prioridad 2: inscritos primero
										if (a.inscrito === true && b.inscrito === false) return -1; // 'a' va antes si está inscrito
										if (a.inscrito === false && b.inscrito === true) return 1; // 'b' va antes si está inscrito
										// Ordenar por el campo y la dirección seleccionados
										const valorA =
											a[ordenList.campo]?.toString().toLowerCase() || "";
										const valorB =
											b[ordenList.campo]?.toString().toLowerCase() || "";
										return ordenList.direccion === "asc"
												? valorA.localeCompare(valorB, "es", { sensitivity: "base" })
												: valorB.localeCompare(valorA, "es", { sensitivity: "base" });
										}).map((elem) => (
										<tr
											className={`table-results--tr ${
												elem?.inscrito ? "apuntado" : ""
											}`}
											key={elem?.idAso}>
											{accionesPorAsociado[elem.idAso].length > 0 ? (
												<td className="table-results--td table-button tiny-column">
													<div
														className="menu-wrapper"
														ref={(el) => (menuRefs.current[elem.idAso] = el)}>
														<OptionsIcon
															onClick={() => toggleMenu(elem.idAso)}
															className="table-button__icon black"
														/>
														{activeMenu === elem.idAso && (
															<FloatingMenu
																anchorRef={{
																	current: menuRefs.current[elem.idAso],
																}}
																onClose={() => setActiveMenu(null)}
																id={elem.idAso}>
																{accionesPorAsociado[elem.idAso].map(
																	(accion, i) =>
																		accion.link ? (
																			<li key={i}>
																				<Link
																					className="no-decoration"
																					to={accion.href}>
																					{accion.icon}
																					<span>{accion.label}</span>
																				</Link>
																			</li>
																		) : (
																			<li key={i} onClick={accion.onClick}>
																				{accion.icon}
																				<span>{accion.label}</span>
																			</li>
																		)
																)}
															</FloatingMenu>
														)}
													</div>
												</td>
											) : (
												<td className="table-results--td table-button tiny-column">
													<OptionsIcon
														onClick={() => toggleMenu(elem.idAso)}
														className="table-button__icon black disable-actions"
													/>
												</td>
											)}

											<td className="table-results--td table-button tiny-column">
												{(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz && inscritoTemp(elem)) ? (
													<button
														className={`${
															(Cambios.some((al) => al.idAso === elem.idAso) && Cambios.find((al) => al.idAso === elem.idAso).pagado) || 
															(elem.pagado && !Cambios.some((al) => al.idAso === elem.idAso))
																? "table--button"
																: "table--button__disabled"
														} ${
															cambiado(elem, "PAGADO", null)
																? "cambiado"
																: "no-cambiado"
														}`}
														onClick={() => {
															let nuevoPagado;
															if (Cambios.some((al) => al.idAso === elem.idAso)){
																nuevoPagado = !Cambios.find((al) => al.idAso === elem.idAso).pagado;
																setCambios((prevCambios) => {
																const actualizado = { ...Cambios.find((al) => al.idAso === elem.idAso), pagado: nuevoPagado };
																// Encontrar el alumno original
																const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																if (!original) return prevCambios;
																// Ver si son iguales después del cambio
																const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																if (iguales) {
																	// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																	return prevCambios.filter((al) => al.idAso !== elem.idAso);
																} else {
																	// Si no es igual, lo añadimos o actualizamos
																	const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																	if (yaExiste) {
																		return prevCambios.map((al) =>
																			al.idAso === elem.idAso ? actualizado : al
																		);
																	} else {
																		return [...prevCambios, actualizado];
																	}
																}
															});
															}else{
																nuevoPagado = !elem.pagado;
																setCambios((prevCambios) => {
																const actualizado = { ...elem, pagado: nuevoPagado };
																// Encontrar el alumno original
																const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																if (!original) return prevCambios;
																// Ver si son iguales después del cambio
																const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																if (iguales) {
																	// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																	return prevCambios.filter((al) => al.idAso !== elem.idAso);
																} else {
																	// Si no es igual, lo añadimos o actualizamos
																	const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																	if (yaExiste) {
																		return prevCambios.map((al) =>
																			al.idAso === elem.idAso ? actualizado : al
																		);
																	} else {
																		return [...prevCambios, actualizado];
																	}
																}
															});
															}
														}}>
														<PagoIcon className="tiny-icon" />
													</button>
													) : (
													elem.pagado && <CheckIcon className="tiny-icon" />
												)}
											</td>
											<td className="table-results--td table-button tiny-column">
												{(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz && inscritoTemp(elem)) ? (
													<button
														className={`${
															(Cambios.some((al) => al.idAso === elem.idAso) && Cambios.find((al) => al.idAso === elem.idAso).asistencia) || 
															(elem.asistencia && !Cambios.some((al) => al.idAso === elem.idAso))
																? "table--button"
																: "table--button__disabled"
														} ${
															cambiado(elem, "ASISTENCIA", null)
																? "cambiado"
																: "no-cambiado"
														}`}
														onClick={() => {
															let nuevoAsistencia;
															if (Cambios.some((al) => al.idAso === elem.idAso)){
																nuevoAsistencia = !Cambios.find((al) => al.idAso === elem.idAso).asistencia;
																setCambios((prevCambios) => {
																const actualizado = { ...Cambios.find((al) => al.idAso === elem.idAso), asistencia: nuevoAsistencia };
																// Encontrar el alumno original
																const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																if (!original) return prevCambios;
																// Ver si son iguales después del cambio
																const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																if (iguales) {
																	// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																	return prevCambios.filter((al) => al.idAso !== elem.idAso);
																} else {
																	// Si no es igual, lo añadimos o actualizamos
																	const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																	if (yaExiste) {
																		return prevCambios.map((al) =>
																			al.idAso === elem.idAso ? actualizado : al
																		);
																	} else {
																		return [...prevCambios, actualizado];
																	}
																}
															});
															}else{
																nuevoAsistencia = !elem.asistencia;
																setCambios((prevCambios) => {
																const actualizado = { ...elem, asistencia: nuevoAsistencia };
																// Encontrar el alumno original
																const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																if (!original) return prevCambios;
																// Ver si son iguales después del cambio
																const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																if (iguales) {
																	// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																	return prevCambios.filter((al) => al.idAso !== elem.idAso);
																} else {
																	// Si no es igual, lo añadimos o actualizamos
																	const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																	if (yaExiste) {
																		return prevCambios.map((al) =>
																			al.idAso === elem.idAso ? actualizado : al
																		);
																	} else {
																		return [...prevCambios, actualizado];
																	}
																}
															});
															}
															
														}}>
														<AsistenciaIcon className="tiny-icon" />
													</button>
												) : (
													elem.asistencia && <CheckIcon className="tiny-icon" />
												)}
											</td>

											{Curso?.aSesion.map((sesion) =>
												sesion.tipo === "S" ? (
													<td
														className="table-results--td table-button tiny-column"
														key={sesion.idses}>
														<div
															className={
																cambiado(elem, "SESIONES", sesion.idses)
																	? "cambiado"
																	: "no-cambiado"
															}>
															<input
																type="checkbox"
																title={sesion.descripcion}
																className={`carnet-checkbox ${!perfil_admin && !(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz) && Curso?.estado === "Terminado" ? "disabled" : ""}`}
																disabled={
																	(!perfil_admin && !(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz) &&
																	Curso?.estado === "Terminado")
																}
																checked={
																	(Cambios.some((al) => al.idAso === elem.idAso) && Array.isArray(Cambios.find((al) => al.idAso === elem.idAso).sesiones) && Cambios.find((al) => al.idAso === elem.idAso).sesiones.some((ele) => ele.idsesion === sesion.idses)) || 
																	((!Cambios.some((al) => al.idAso === elem.idAso) && Array.isArray(elem.sesiones) && elem.sesiones.some((ele) => ele.idsesion === sesion.idses)))
																}
																onChange={() => {
																	let nuevasSesiones;
																	if (!Cambios.find((al) => al.idAso === elem.idAso)){
																		if (elem.sesiones.some((al) => al.idsesion === sesion.idses)){
																			nuevasSesiones = elem.sesiones.filter((al) => al.idsesion !== sesion.idses)
																		}else{
																			nuevasSesiones = [
																				...elem.sesiones.filter((al) => al.idsesion !== sesion.idses),
																				{
																					asistencia: elem.asistencia,
																					idsesion: sesion.idses,
																					nasisevento: 1,
																					pagado: elem.pagado,
																					tipo: "S",
																				}
																			]
																		}
																		setCambios((prevCambios) => {
																		const actualizado = { ...elem, sesiones: nuevasSesiones };
																		// Encontrar el alumno original
																		const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																		if (!original) return prevCambios;
																		// Ver si son iguales después del cambio
																		const iguales = Object.keys(original)
																		.every(
																			(key) =>
																				JSON.stringify(original[key]) === JSON.stringify(actualizado[key])
																		);
																		if (iguales) {
																			// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																			return prevCambios.filter((al) => al.idAso !== elem.idAso);
																		} else {
																			// Si no es igual, lo añadimos o actualizamos
																			const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																			if (yaExiste) {
																				return prevCambios.map((al) =>
																					al.idAso === elem.idAso ? actualizado : al
																				);
																			} else {
																				return [...prevCambios, actualizado];
																			}
																		}
																	});
																	}else{
																		// nuevasSesiones = Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses)
																		if (Cambios.find((al) => al.idAso === elem.idAso).sesiones.some((ele) => ele.idsesion === sesion.idses)){
																			nuevasSesiones = Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses)
																		}else{
																			nuevasSesiones = [
																				...Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses),
																				{
																					asistencia: elem.asistencia,
																					idsesion: sesion.idses,
																					nasisevento: 1,
																					pagado: elem.pagado,
																					tipo: "S",
																				}
																			]
																		}
																		setCambios((prevCambios) => {
																		const actualizado = { ...Cambios.find((al) => al.idAso === elem.idAso), sesiones: nuevasSesiones };
																		// Encontrar el alumno original
																		const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																		if (!original) return prevCambios;
																		// Ver si son iguales después del cambio
																		const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																		if (iguales) {
																			// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																			return prevCambios.filter((al) => al.idAso !== elem.idAso);
																		} else {
																			// Si no es igual, lo añadimos o actualizamos
																			const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																			if (yaExiste) {
																				return prevCambios.map((al) =>
																					al.idAso === elem.idAso ? actualizado : al
																				);
																			} else {
																				return [...prevCambios, actualizado];
																			}
																		}
																	});
																	}
																}
															}
															/>
														</div>
													</td>
												) : sesion.tipo === "E" ? (
													<td
														className="table-results--td table-button short-column-expanded"
														key={sesion.idses}>
														<div
															className={`evento-selector ${
																cambiado(elem, "SESIONES", sesion.idses)
																	? "cambiado"
																	: "no-cambiado"
															}`}>
															<div className="flex-wrapper no-gap">
																<button
																	title={elem.descripcion}
																	className={`button contrast left-radius ${
																		!perfil_admin && !(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz) && Curso?.estado === "Terminado"
																			? "disabled"
																			: ""
																	}`}
																	onClick={() => {
																		let valor = 0;
																		if (Cambios.some((ele) => ele.idAso === elem.idAso) && Array.isArray(Cambios.find((al) => al.idAso === elem.idAso).sesiones)){
																			valor =(Cambios.find((al) => al.idAso === elem.idAso).sesiones.find((ele) => ele.idsesion === sesion.idses)?.nasisevento || 0) - 1;
																		}else{
																			valor =(elem.sesiones.find((ele) => ele.idsesion === sesion.idses)?.nasisevento || 0) - 1;
																		}
																		if (valor < 0) return
																		let nuevasSesiones;
																	if (!Cambios.find((al) => al.idAso === elem.idAso)){
																		nuevasSesiones = [
																			...elem.sesiones.filter((al) => al.idsesion !== sesion.idses),
																			{
																				asistencia: elem.asistencia,
																				idsesion: sesion.idses,
																				nasisevento: valor,
																				pagado: elem.pagado,
																				tipo: "E",
																			}
																		]
																		setCambios((prevCambios) => {
																		const actualizado = { ...elem, sesiones: nuevasSesiones };
																		// Encontrar el alumno original
																		const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																		if (!original) return prevCambios;
																		// Ver si son iguales después del cambio
																		const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																		if (iguales) {
																			// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																			return prevCambios.filter((al) => al.idAso !== elem.idAso);
																		} else {
																			// Si no es igual, lo añadimos o actualizamos
																			const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																			if (yaExiste) {
																				return prevCambios.map((al) =>
																					al.idAso === elem.idAso ? actualizado : al
																				);
																			} else {
																				return [...prevCambios, actualizado];
																			}
																		}
																	});
																	}else{
																		// nuevasSesiones = Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses)
																		if (valor === 0){
																			nuevasSesiones = Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses)
																		}else{
																			nuevasSesiones = [
																				...Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses),
																				{
																					asistencia: elem.asistencia,
																					idsesion: sesion.idses,
																					nasisevento: valor,
																					pagado: elem.pagado,
																					tipo: "E",
																				}
																			]
																		}
																		setCambios((prevCambios) => {
																		const actualizado = { ...Cambios.find((al) => al.idAso === elem.idAso), sesiones: nuevasSesiones };
																		// Encontrar el alumno original
																		const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																		if (!original) return prevCambios;
																		// Ver si son iguales después del cambio
																		const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																		if (iguales) {
																			// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																			return prevCambios.filter((al) => al.idAso !== elem.idAso);
																		} else {
																			// Si no es igual, lo añadimos o actualizamos
																			const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																			if (yaExiste) {
																				return prevCambios.map((al) =>
																					al.idAso === elem.idAso ? actualizado : al
																				);
																			} else {
																				return [...prevCambios, actualizado];
																			}
																		}
																	});
																	}
																	}}></button>
																<input
																	value={
																		(Cambios.some((al) => al.idAso === elem.idAso) && Array.isArray(Cambios.find((al) => al.idAso === elem.idAso).sesiones) &&
																			Cambios.find((al) => al.idAso === elem.idAso).sesiones.find((ele) => ele.idsesion === sesion.idses)?.nasisevento) || 
																			((!Cambios.some((al) => al.idAso === elem.idAso) && Array.isArray(elem.sesiones) &&
																			elem.sesiones.find((ele) => ele.idsesion === sesion.idses)?.nasisevento) || "") || ""
																	}
																	className="input-calculated no-radius"
																	disabled={true}
																/>
																<button
																	className={`button contrast right-radius ${
																		!perfil_admin && !(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz) && Curso?.estado === "Terminado"
																			? "disabled"
																			: ""
																	}`}
																	onClick={() => {
																		let valor = 0;
																		if (Cambios.some((ele) => ele.idAso === elem.idAso) && Array.isArray(Cambios.find((al) => al.idAso === elem.idAso).sesiones)){
																			valor =(Cambios.find((al) => al.idAso === elem.idAso).sesiones.find((ele) => ele.idsesion === sesion.idses)?.nasisevento || 0) + 1;
																		}else{
																			valor =(elem.sesiones.find((ele) => ele.idsesion === sesion.idses)?.nasisevento || 0) + 1;
																		}
																		let nuevasSesiones;
																	if (!Cambios.find((al) => al.idAso === elem.idAso)){
																		nuevasSesiones = [
																			...elem.sesiones.filter((al) => al.idsesion !== sesion.idses),
																			{
																				asistencia: elem.asistencia,
																				idsesion: sesion.idses,
																				nasisevento: valor,
																				pagado: elem.pagado,
																				tipo: "E",
																			}
																		]
																		setCambios((prevCambios) => {
																		const actualizado = { ...elem, sesiones: nuevasSesiones };
																		// Encontrar el alumno original
																		const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																		if (!original) return prevCambios;
																		// Ver si son iguales después del cambio
																		const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																		if (iguales) {
																			// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																			return prevCambios.filter((al) => al.idAso !== elem.idAso);
																		} else {
																			// Si no es igual, lo añadimos o actualizamos
																			const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																			if (yaExiste) {
																				return prevCambios.map((al) =>
																					al.idAso === elem.idAso ? actualizado : al
																				);
																			} else {
																				return [...prevCambios, actualizado];
																			}
																		}
																	});
																	}else{
																		// nuevasSesiones = Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses)
																		if (valor === 0){
																			nuevasSesiones = Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses)
																		}else{
																			nuevasSesiones = [
																				...Cambios.find((al) => al.idAso === elem.idAso).sesiones.filter((al) => al.idsesion !== sesion.idses),
																				{
																					asistencia: elem.asistencia,
																					idsesion: sesion.idses,
																					nasisevento: valor,
																					pagado: elem.pagado,
																					tipo: "E",
																				}
																			]
																		}
																		setCambios((prevCambios) => {
																		const actualizado = { ...Cambios.find((al) => al.idAso === elem.idAso), sesiones: nuevasSesiones };
																		// Encontrar el alumno original
																		const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																		if (!original) return prevCambios;
																		// Ver si son iguales después del cambio
																		const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																		if (iguales) {
																			// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																			return prevCambios.filter((al) => al.idAso !== elem.idAso);
																		} else {
																			// Si no es igual, lo añadimos o actualizamos
																			const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																			if (yaExiste) {
																				return prevCambios.map((al) =>
																					al.idAso === elem.idAso ? actualizado : al
																				);
																			} else {
																				return [...prevCambios, actualizado];
																			}
																		}
																	});
																	}
																	}}></button>
															</div>
														</div>
													</td>
												) : null
											)}
											{Curso?.actClau&&
												<td className="table-results--td table-button tiny-column">
													<div className={
														cambiado(elem, "CLAUSULA", null)
															? "cambiado"
															: "no-cambiado"
													}>
														<input
															type="checkbox"
															className={`carnet-checkbox ${!perfil_admin && !(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz) && Curso?.estado === "Terminado" ? "disabled" : ""}`}
															disabled={
																(!perfil_admin && !(perfil_adm_dojo && perfil_dojo === Curso?.cfOrganiz) &&
																Curso?.estado === "Terminado")
															}
															checked={
																(Cambios.some((al) => al.idAso === elem.idAso) && Cambios.find((al) => al.idAso === elem.idAso).clausulaAceptada) || 
																(elem.clausulaAceptada && !Cambios.some((al) => al.idAso === elem.idAso))
															}
															onChange={(e) => {
																//setModalClausulas(true);
																const escapeHtml = (s = "") =>
																	s.replace(/&/g, "&amp;")
																	.replace(/</g, "&lt;")
																	.replace(/>/g, "&gt;")
																	.replace(/"/g, "&quot;")
																	.replace(/'/g, "&#39;");

																const toParagraphsWithLineSpans = (s = "") =>
																	s.split(/\r?\n\r?\n+/)
																	.map(p => {
																	const spans = p
																		.split(/\r?\n/)
																		.map(line => `<span class="cl-line">${escapeHtml(line)}</span>`)
																		.join("");
																	return `<p class="cl-paragraph">${spans}</p>`;
																	})
																	.join("");
																
																if ((Cambios.some((al) => al.idAso === elem.idAso) && Cambios.find((al) => al.idAso === elem.idAso).clausulaAceptada) || elem.clausulaAceptada){
																	if (Cambios.some((al) => al.idAso === elem.idAso)){
																			// nuevoclausula = !Cambios.find((al) => al.idAso === elem.idAso).clausulaAceptada;
																			setCambios((prevCambios) => {
																				const actualizado = { ...Cambios.find((al) => al.idAso === elem.idAso), clausulaAceptada: false };
																				// Encontrar el alumno original
																				const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																				if (!original) return prevCambios;
																				// Ver si son iguales después del cambio
																				const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																				if (iguales) {
																					// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																					return prevCambios.filter((al) => al.idAso !== elem.idAso);
																				} else {
																					// Si no es igual, lo añadimos o actualizamos
																					const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																					if (yaExiste) {
																						return prevCambios.map((al) =>
																							al.idAso === elem.idAso ? actualizado : al
																						);
																					} else {
																						return [...prevCambios, actualizado];
																					}
																				}
																			});
																		}else{
																		// nuevoclausula = !elem.clausulaAceptada;
																		setCambios((prevCambios) => {
																			const actualizado = { ...elem, clausulaAceptada: false };
																			// Encontrar el alumno original
																			const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																			if (!original) return prevCambios;
																			// Ver si son iguales después del cambio
																			const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																			if (iguales) {
																				// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																				return prevCambios.filter((al) => al.idAso !== elem.idAso);
																			} else {
																				// Si no es igual, lo añadimos o actualizamos
																				const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																				if (yaExiste) {
																					return prevCambios.map((al) =>
																						al.idAso === elem.idAso ? actualizado : al
																					);
																				} else {
																					return [...prevCambios, actualizado];
																				}
																			}
																		});
																	}
																	return
																}
																Swal.fire({
																	title: loc("Cláusulas opcionales:"),
																	html: toParagraphsWithLineSpans(Curso?.clau ?? ""),
																	width:'60%',
																	icon: "question",
																	showCancelButton: true,
																	confirmButtonText: loc("Acepto"),
																	cancelButtonText: loc("No Acepto"),
																	customClass: {
																	popup: 'clausulas-alert',
																	htmlContainer: 'clausulas-html',
																	},
																}).then((result) => {
																	// let nuevoclausula;
																	if (result.isConfirmed){
																		if (Cambios.some((al) => al.idAso === elem.idAso)){
																			// nuevoclausula = !Cambios.find((al) => al.idAso === elem.idAso).clausulaAceptada;
																			setCambios((prevCambios) => {
																				const actualizado = { ...Cambios.find((al) => al.idAso === elem.idAso), clausulaAceptada: result.isConfirmed };
																				// Encontrar el alumno original
																				const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																				if (!original) return prevCambios;
																				// Ver si son iguales después del cambio
																				const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																				if (iguales) {
																					// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																					return prevCambios.filter((al) => al.idAso !== elem.idAso);
																				} else {
																					// Si no es igual, lo añadimos o actualizamos
																					const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																					if (yaExiste) {
																						return prevCambios.map((al) =>
																							al.idAso === elem.idAso ? actualizado : al
																						);
																					} else {
																						return [...prevCambios, actualizado];
																					}
																				}
																			});
																		}else{
																		// nuevoclausula = !elem.clausulaAceptada;
																		setCambios((prevCambios) => {
																			const actualizado = { ...elem, clausulaAceptada: result.isConfirmed };
																			// Encontrar el alumno original
																			const original = AlumnosList.find((al) => al.idAso === elem.idAso);
																			if (!original) return prevCambios;
																			// Ver si son iguales después del cambio
																			const iguales = sonIgualesIgnorandoOrden(original, actualizado);
																			if (iguales) {
																				// Si el nuevo objeto es igual al original, lo quitamos de Cambios
																				return prevCambios.filter((al) => al.idAso !== elem.idAso);
																			} else {
																				// Si no es igual, lo añadimos o actualizamos
																				const yaExiste = prevCambios.some((al) => al.idAso === elem.idAso);
																				if (yaExiste) {
																					return prevCambios.map((al) =>
																						al.idAso === elem.idAso ? actualizado : al
																					);
																				} else {
																					return [...prevCambios, actualizado];
																				}
																			}
																		});
																	}
																	}
																});
																// if (true) setModalClausulas(true);
															}}
														/>
													</div>
												</td>
											}

											<td className="table-results--td avatar-row wide-column relative overflowx-visible">
												<img
													src={"/avatars/" + (elem?.avatar ?? "default.jpg")}
													alt=""
												/>{" "}
												{elem?.numacae}
											</td>
											<td className="table-results--td table-button black ocultamovil">
												<div className="flex-row-item gap-tiny">
													<div className="grow text-ellipsis">
														{elem.nombre} {elem?.apellido}
													</div>
													{elem?.idAso === props.idAsociado && (
														<UserIcon className="table-icon" />
													)}
												</div>
											</td>
											<td className="table-results--td table-button black ocultamovil">
												<span className="grow text-ellipsis">{elem?.dojo}</span>
											</td>
											<td className="table-results--td wide-column">
												{loc(elem?.adulto)}
											</td>
											<td className="table-results--td wide-column">
												{elem?.ultima_cuota}
											</td>
										</tr>
									))}
							</tbody>
						</table>
					</div>
					<div className="modal-footer sticky-footer">
						<div className="flex-row-item space-between">
							{(perfil_admin || perfil_adm_dojo) && (
								<button className="button secondary" onClick={() => setModoInscripcion(!modoInscripcion)}>
									{modoInscripcion ? loc("Vista normal") : loc("Modo inscripción")}
								</button>
							)}
							<div className="flex-wrapper flex-end button-container">
								<button
									className={
										(Cambios &&
										Cambios.length > 0 
											? "button secondary"
											: "button secondary desactivar")
									}
									onClick={() => {
										setCambios([]);
									}}
								>
									{loc("Descartar cambios")}
								</button>
								<button
									className={
										(Cambios &&
										Cambios.length > 0
											? "button primary"
											: "button primary desactivar")
									}
									onClick={() => {
										guarda();
									}}
								>
									{loc("Guardar cambios")}
								</button>
							</div>
						</div>
					</div>
				</div>
				<CursoImagenMod
					show={verImagen}
					image={"/curso/" + Curso?.imagen}
					onHide={() => setVerImagen(false)}
				/>
				{modalClausulas && (
                    <main className="modal-wrapper" id="modal-clausulas">
                        <div className="modal-container backdrop content-wrapper grados">
                            <div className="modal-header">
                                <div className="flex-wrapper">
                                    <AgreementIcon className="section-icon" />
                                    <h3>{loc("Cláusulas")}</h3>
                                </div>
                            </div>
                            <div className="modal-content-scroll inscripciones" ref={clausulasScrollRef}>
                                <div className="modal-content-outer-wrapper">
                                    {Array.from({ length: 101 }, (_, i) => (
                                        <div key={i}>Test</div>
                                    ))}
                                </div>
                            </div>
                            <div className="modal-footer sticky-footer">
                                <div className="flex-row-item">
                                    <div className="flex-wrapper flex-end button-container">
                                        <button
                                            className={`button secondary ${!hasReadClausulas ? "disabled" : ""}`}
                                            onClick={() => {
                                                if (!hasReadClausulas) return;
                                                setModalClausulas(false);
                                            }}
                                        >
                                            {loc("Rechazar cláusulas")}
                                        </button>
                                        <button
                                            className={`button primary ${!hasReadClausulas ? "disabled" : ""}`}
                                            onClick={() => {
                                                if (!hasReadClausulas) return;
                                                setModalClausulas(false);
                                            }}
                                        >
                                            {loc("Aceptar cláusulas")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                )}
			</main>
		);
};

export default InscripcionMod;
